import React from "react";

// Convert a 2-letter ISO country code to the flag emoji.
// e.g. "US" -> 🇺🇸. Returns null when code is missing.
export function flagEmoji(code) {
  if (!code || code.length !== 2) return null;
  const cc = code.toUpperCase();
  return String.fromCodePoint(
    ...[...cc].map((c) => 0x1f1e6 - 65 + c.charCodeAt(0)),
  );
}

/**
 * Tiny inline IP + GeoIP chip for admin tables.
 * Renders: "<flag> <city> · <ip>" or just "<ip>" when no geo is available.
 */
export default function IpGeoChip({ label, ip, geo, testid }) {
  if (!ip) return null;
  const flag = flagEmoji(geo?.country_code);
  const place = [geo?.city, geo?.country].filter(Boolean).join(", ");
  const isPrivate = geo?.private;
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] text-zinc-600 font-mono"
      title={[geo?.isp, geo?.region, ip].filter(Boolean).join(" · ")}
      data-testid={testid}
    >
      {label && <span className="text-zinc-400">{label}</span>}
      {flag && <span className="text-[13px] leading-none">{flag}</span>}
      {place && !isPrivate && (
        <span className="text-zinc-700 font-sans">{place}</span>
      )}
      {isPrivate && <span className="italic text-zinc-400">private</span>}
      <span className="text-zinc-500">{ip}</span>
    </span>
  );
}
